export const columnConfig = [
  {
    id: "memberId",
    label: "MH ID",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "86px",
    dataColoumn: "memberId",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "memberId",
    searchInput: true,
    searchPlaceholder: "12345",
    sortIcons: true,
  },

  {
    id: "agentName",
    label: "Agent Name",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "90px",
    dataColoumn: "agentName",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "agentName",
    searchInput: true,
    dynamicDropdown: "agentNames",
    sortIcons: true,
  },

  {
    id: "engagementDate",
    label: "Engagement Date",
    coloumnType: "capsule-date",
    className: "table-head--width",
    columnWidth: "92px",
    dataColoumn: "engagementDate1",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "20px",
    linkTo: "null",
    sortExpression: "engagementDate",
    searchInput: true,
    searchPlaceholder: "MM/DD/YYYY",
    sortIcons: true,
  },

  {
    id: "CallCategory",
    label: "Call Category",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "112px",
    dataColoumn: "callCategory",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "callCategory",
    searchInput: true,
    dynamicDropdown: "callCategories",
    sortIcons: true,
  },
  {
    id: "CRSScore",
    label: "MN Score",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "76px",
    dataColoumn: "crsTotalScoreOfFive",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "crsTotalScoreOfFive",
    searchInput: true,
    dropdownOptions: ["0-1", "1-2", "2-3", "3-4", "4-5", "N/A"],
    dropdownLabels: {
      "0-1": "0 \u2264 1",
      "1-2": "1 \u2264 2",
      "2-3": "2 \u2264 3",
      "3-4": "3 \u2264 4",
      "4-5": "4 \u2264 5",
    },
    sortIcons: true,
  },
  {
    id: "FeedbackStatus",
    label: "Testing Feedbacks",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "82px",
    dataColoumn: "FeedbackStatus",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "FeedbackStatus",
    searchInput: true,
    dropdownOptions: ["Yes", "No"],
    sortIcons: true,
  },

  {
    id: "qualityOfCall",
    label: "Global Score",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "76px",
    dataColoumn: "qualityOfCall",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "qualityOfCall",
    searchInput: true,
    dropdownOptions: ["0-1", "1-2", "2-3", "3-4", "4-5", "N/A"],
    dropdownLabels: {
      "0-1": "0 \u2264 1",
      "1-2": "1 \u2264 2",
      "2-3": "2 \u2264 3",
      "3-4": "3 \u2264 4",
      "4-5": "4 \u2264 5",
    },
    sortIcons: true,
  },
  {
    id: "urgency",
    label: "Follow-Up Urgency",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "88px",
    dataColoumn: "urgency",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "urgency",
    searchInput: true,
    searchPlaceholder: "urgency",
    sortIcons: true,
    dropdownOptions: ["High", "Medium", "Low", "N/A"],
  },
  {
    id: "insight",
    label: "Insight",
    coloumnType: "underlinedText",
    className: "table-head--width",
    columnWidth: "78px",
    dataColoumn: "insight",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "insight",
    searchInput: false,
    searchPlaceholder: "NA",
  },
  {
    id: "callStatus",
    label: "Follow-up Status",
    coloumnType: "statusButton",
    className: "table-head--width",
    columnWidth: "92px",
    dataColoumn: "status",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "status",
    searchInput: true,
    dropdownOptions: ["Open", "Closed", "In-Progress", "N/A"],
    // sortIcons: true,
  },
  {
    id: "memberName",
    label: "Member Name",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "96px",
    dataColoumn: "memberName",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "memberName",
    searchInput: true,
    searchPlaceholder: "John Doe",
    sortIcons: true,
  },
  {
    id: "customerPhone",
    label: "Call From/To",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "110px",
    dataColoumn: "customerPhone",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "customerPhone",
    searchInput: true,
    searchPlaceholder: "555-123-4567",
    sortIcons: true,
  },
  {
    id: "CallType",
    label: "Call Type",
    coloumnType: "regular",
    className: "table-head--width",
    columnWidth: "76px",
    dataColoumn: "CallType",
    color: "#616161",
    backgroundColor: "white",
    fontSize: "13px",
    linkTo: "null",
    sortExpression: "CallType",
    searchInput: true,
    dropdownOptions: ["Inbound", "Outbound"],
    sortIcons: true,
  },
];
